import {
  Box,
  Typography,
  Grid,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import ModalsWrapper from '../../../Components/Modals/ModalsWrapper';
import PdfAndImageView from '../../../Components/pdfAndImageView/PdfAndImageView';
import { useState } from 'react';
import { CommonTypoGraphy } from '../../../Components/pdfAndImageView/CommonTypoGraphy';
import { IViewCompanyBusinessLicenseInfo } from '../../../rest/types';
import CommonDetailItem from '../../../Components/CommonDetailItem/CommonDetailItem';

type IProps = {
  companyBusinessLicense: IViewCompanyBusinessLicenseInfo;
};

const CardBusinessLicense = ({ companyBusinessLicense }: IProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<string | null>('');

  const bizLicense = companyBusinessLicense?.companyBusinessLicense;
  const assocMem = companyBusinessLicense?.companyAssociationMembership;

  return (
    <>
      <Box p={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Typography variant='h6' gutterBottom sx={{ fontWeight: 'bold' }}>
              Other business license & membership information
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                flexWrap: 'wrap',
                gap: 1,
                mb: 2,
              }}
            >
              <FormControlLabel
                checked={Boolean(bizLicense?.hajj_license)}
                disabled
                control={<Checkbox />}
                label='Hajj'
              />
              <FormControlLabel
                checked={Boolean(bizLicense?.umrah_license)}
                disabled
                control={<Checkbox />}
                label='Umrah'
              />
              <FormControlLabel
                checked={Boolean(bizLicense?.recruting_license)}
                disabled
                control={<Checkbox />}
                label='Recruiting'
              />
              <FormControlLabel
                checked={Boolean(assocMem?.baira_membership)}
                disabled
                control={<Checkbox />}
                label='Baira'
              />
              <FormControlLabel
                checked={Boolean(assocMem?.haab_membership)}
                disabled
                control={<Checkbox />}
                label='Haab'
              />
              <FormControlLabel
                checked={Boolean(assocMem?.iata_membership)}
                disabled
                control={<Checkbox />}
                label='IATA'
              />
              <FormControlLabel
                checked={Boolean(assocMem?.tdab_membership)}
                disabled
                control={<Checkbox />}
                label='TDAB'
              />
              <FormControlLabel
                checked={Boolean(assocMem?.toab_membership)}
                disabled
                control={<Checkbox />}
                label='TOAB'
              />
            </Box>

            <Grid container spacing={2}>
              {bizLicense?.hajj_license_file && (
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  label='Hajj license'
                  value={
                    <CommonTypoGraphy
                      name='View hajj license'
                      onClick={() => {
                        setOpen(true);
                        setImageFile(bizLicense.hajj_license_file);
                      }}
                    />
                  }
                />
              )}
              {bizLicense?.umrah_license_file && (
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  label='Umrah license'
                  value={
                    <CommonTypoGraphy
                      name='View Umrah license'
                      onClick={() => {
                        setOpen(true);
                        setImageFile(bizLicense.umrah_license_file);
                      }}
                    />
                  }
                />
              )}
              {bizLicense?.recruting_license_file && (
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  label='Recruiting license'
                  value={
                    <CommonTypoGraphy
                      name='View Recruiting license'
                      onClick={() => {
                        setOpen(true);
                        setImageFile(bizLicense.recruting_license_file);
                      }}
                    />
                  }
                />
              )}
              {assocMem?.baira_membership_file && (
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  label='Baira license'
                  value={
                    <CommonTypoGraphy
                      name='View Baira license'
                      onClick={() => {
                        setOpen(true);
                        setImageFile(assocMem.baira_membership_file);
                      }}
                    />
                  }
                />
              )}
              {assocMem?.haab_membership_file && (
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  label='Haab license'
                  value={
                    <CommonTypoGraphy
                      name='View Haab license'
                      onClick={() => {
                        setOpen(true);
                        setImageFile(assocMem.haab_membership_file);
                      }}
                    />
                  }
                />
              )}
              {assocMem?.iata_membership_file && (
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  label='IATA license'
                  value={
                    <CommonTypoGraphy
                      name='View IATA license'
                      onClick={() => {
                        setOpen(true);
                        setImageFile(assocMem.iata_membership_file);
                      }}
                    />
                  }
                />
              )}
              {assocMem?.toab_membership_file && (
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  label='TOAB license'
                  value={
                    <CommonTypoGraphy
                      name='View TOAB license'
                      onClick={() => {
                        setOpen(true);
                        setImageFile(assocMem.toab_membership_file);
                      }}
                    />
                  }
                />
              )}
              {assocMem?.tdab_membership_file && (
                <CommonDetailItem
                  xs={12}
                  sm={6}
                  md={6}
                  label='TDAB license'
                  value={
                    <CommonTypoGraphy
                      name='View TDAB license'
                      onClick={() => {
                        setOpen(true);
                        setImageFile(assocMem.tdab_membership_file);
                      }}
                    />
                  }
                />
              )}
            </Grid>
          </Grid>

          <Grid item xs={12} md={12}>
            <Typography variant='h6' gutterBottom sx={{ fontWeight: 'bold' }}>
              Involved in tourism activities information
            </Typography>
            <Box
              sx={{
                display: 'flex',
                gap: 4,
                alignItems: 'center',
                flexWrap: 'wrap',
              }}
            >
              <FormControlLabel
                checked={Boolean(bizLicense?.inbound)}
                disabled
                control={<Checkbox />}
                label='Inbound'
              />
              <FormControlLabel
                checked={Boolean(bizLicense?.outbound)}
                disabled
                control={<Checkbox />}
                label='Outbound'
              />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <ModalsWrapper
        modalData={{ title: 'View document' }}
        setShowModal={setOpen}
        showModal={open}
      >
        <PdfAndImageView file={imageFile} />
      </ModalsWrapper>
    </>
  );
};

export default CardBusinessLicense;
